import React, { useState } from "react";
import FormContainer from "../../componentes/form-container/FormContainer";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import RegionCountry from "./RegionCountry";
import RegionState from "./RegionState";
import RegionCity from "./RegionCity";
import { makeStyles } from "@material-ui/core";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const RegionControl = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event, newValue) => setTabValue(newValue);

    return (
        <FormContainer>
            <CustomTabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="supplier tab"
            >
                <CustomTabStyle label={t("country")} {...a11yProps(0)}
                    icon={<CreateOutlinedIcon fontSize="small" classes={classes} />} />
                <CustomTabStyle label={t("state")} {...a11yProps(1)}
                    icon={<CreateOutlinedIcon fontSize="small" classes={classes} />} />
                <CustomTabStyle label={t("city")} {...a11yProps(2)}
                    icon={<CreateOutlinedIcon fontSize="small" classes={classes} />} />

            </CustomTabs>
            <TabPanel value={tabValue} index={0}>
                <RegionCountry />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <RegionState />
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
                <RegionCity />
            </TabPanel>
        </FormContainer>


    );
};

export default RegionControl;